function StepOptions({
  optionType,
  optionLayout = "vertical",
  options,
  userSelections,
  setUserSelections,
  resetCalculator,
}) {
  const onOptionChange = (e) => {
    // select container group
    const currentOptions = e.target.closest(".cost-comparison-tool__options");
    // remove error message
    currentOptions.querySelector(".cost-comparison-tool__field-error-message").innerHTML = "";

    const nextUserSelections = { ...userSelections, [e.target.name]: e.target.value };
    setUserSelections(nextUserSelections);

    if (optionType === "people" || optionType === "solution") {
      resetCalculator(nextUserSelections);
    }
  };
  return (
    <>
      <div id={`${optionType}-options`} className={`cost-comparison-tool__options`} data-option-type={optionType}>
        {options["question"] && <p className="cost-comparison-tool__options__title">{options["question"]}</p>}
        <div className="cost-comparison-tool__field-error-message"></div>
        <div className={`cost-comparison-tool__radio-group radio-group radio-group--${optionLayout}`}>
          {Object.entries(options["options"]).map(([key, value]) => (
            <fieldset className="radio-group__fieldset" key={key}>
              <label className="radio-group__label" htmlFor={`${optionType}-${key}`}>
                {value}
              </label>
              <input
                className="radio-group__input"
                type="radio"
                name={`${optionType}`}
                id={`${optionType}-${key}`}
                value={key}
                onChange={onOptionChange}
                checked={key === userSelections[optionType]}
              />
            </fieldset>
          ))}
        </div>
      </div>
    </>
  );
}
